/**
 * PerceptionMask enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file PerceptionMask.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum PerceptionMask {
  SEEN = 0x01,
  HEARD = 0x02,
  SEEN_AND_HEARD = 0x03,
  INAUDIBLE = 0x04, // ???
  INVISIBLE = 0x08, // ???
}